import * as React from "react";
import { PageHeader, DocumentTitle, Spinner } from "components/common";
import DocsHelper from "util/DocsHelper";
import UserSearchFilterCreate from "search-filter/components/filter-management-pages/UserSearchFilterCreate";
import SearchFiltersPageSubactions from "search-filter/components/filter-management-pages/SearchFiltersPageSubactions";
import { InvalidLicenseWarning } from "license/LicenseCheck";
import useSearchFilterLicenseStatus from "search-filter/hooks/useSearchFilterLicenseStatus";
const MyFiltersOverviewPage = () => {
  const { isFetchingLicense, isValidLicense } = useSearchFilterLicenseStatus();
  if (isFetchingLicense) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: 'Create Filter For "MyFilters" collection' }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: 'Create Filter For "My Filters" collection',
      actions: /* @__PURE__ */ React.createElement(SearchFiltersPageSubactions, { licenseIsValid: isValidLicense }),
      documentationLink: {
        title: "Search filter documentation",
        path: DocsHelper.PAGES.SEARCH_FILTERS
      }
    },
    /* @__PURE__ */ React.createElement("span", null, 'Create a new search filter. The filter will be added to your "My Filters" collection and can be included in any search and dashboard widget by using the controls in the related search bar.')
  ), isValidLicense ? /* @__PURE__ */ React.createElement(UserSearchFilterCreate, null) : /* @__PURE__ */ React.createElement(
    InvalidLicenseWarning,
    {
      featureName: "search filter",
      licenseSubject: "/license/enterprise/search-filter",
      displayWarningContainer: true
    }
  ));
};
export default MyFiltersOverviewPage;
